import { render, staticRenderFns } from "./MyImgTextList.vue?vue&type=template&id=3f4fa661&scoped=true"
import script from "./MyImgTextList.vue?vue&type=script&lang=js"
export * from "./MyImgTextList.vue?vue&type=script&lang=js"
import style0 from "./MyImgTextList.vue?vue&type=style&index=0&id=3f4fa661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4fa661",
  null
  
)

export default component.exports